import React from "react";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const QUESTIONS = [
  {
    id: "item-1",
    title: "What is Furloop?",
    content:
      "Furloop is an IT asset recovery platform that manages erasure, assessment, reimaging, grading, reporting, and resale workflows from one connected system.",
  },
  {
    id: "item-2",
    title: "Who is Furloop built for?",
    content:
      "ITAD companies, refurbishers, buyback operators, corporate IT teams, recyclers, repair businesses, and ecommerce resellers.",
  },
  {
    id: "item-3",
    title: "Is Furloop only for Windows devices?",
    content:
      "Furloop's strongest early focus is Windows-heavy asset recovery — assessment, reimaging, driver capture, and resale preparation. The platform is designed to support broader device recovery workflows over time.",
  },
  {
    id: "item-4",
    title: "Does Furloop perform secure erasure?",
    content:
      "Furloop supports erasure workflows, erasure tracking, reporting, and integrations. Erasure capabilities and certification options may vary depending on the workflow, deployment, and customer requirements.",
  },
  {
    id: "item-5",
    title: "What does preflight mean?",
    content:
      "Preflight means checking a device before starting critical processing steps — identifying risks such as MDM issues, boot blockers, storage failure, missing drivers, and reimage readiness.",
  },
  {
    id: "item-6",
    title: "What is driver capture and reuse?",
    content:
      "Furloop learns from a known-good device or workflow, stores the driver profile, and reuses it for matching devices to cut repeated manual setup.",
  },
  {
    id: "item-7",
    title: "Is robot automation available now?",
    content:
      "Robot automation is currently in R&D. Furloop is collecting interest from teams that process high volumes of devices and want to explore automated assessment, grading, MDM checks, and trade-in workflows.",
  },
  {
    id: "item-8",
    title: "Can I register for software only — or robot automation only?",
    content:
      "Yes to both. The interest form lets you choose software, robot automation R&D, or both.",
  },
  {
    id: "item-9",
    title: "Can Furloop replace our current tools?",
    content:
      "Furloop is built as a connected workflow platform. Depending on your current process, it may replace some tools, integrate with others, or sit between systems to improve workflow visibility and processing speed.",
  },
];

const Faq = () => {
  return (
    <section id="faq" className="relative bg-brand-bg font-body">
      <div className="mx-auto grid max-w-6xl gap-12 px-6 py-20 lg:grid-cols-[0.8fr_1.2fr] lg:py-28">
        {/* left intro */}
        <div className="lg:sticky lg:top-28 lg:self-start">
          <span className="inline-flex items-center gap-2 rounded-full border border-line bg-white px-3.5 py-1.5 text-xs font-medium uppercase tracking-[0.16em] text-brand-plum">
            FAQ
          </span>
          <h2 className="mt-5 font-display text-3xl font-semibold leading-tight tracking-tight text-brand-plum sm:text-4xl">
            Frequently asked questions
          </h2>
          <p className="mt-4 max-w-md text-base leading-relaxed text-ink">
            Everything teams ask before connecting erasure, assessment, reimaging, grading, and resale into
            one workflow.
          </p>
          <a
            href="#register"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-cta-gradient px-5 py-2.5 text-sm font-semibold text-white no-underline shadow-lg shadow-[#304BEF]/25 transition-transform duration-200 hover:-translate-y-0.5 hover:no-underline"
          >
            Still have questions? Register interest
          </a>
        </div>

        {/* accordion */}
        <Accordion
          type="single"
          collapsible
          defaultValue="item-1"
          className="w-full overflow-hidden rounded-2xl border border-line bg-white"
        >
          {QUESTIONS.map((item) => (
            <AccordionItem
              key={item.id}
              value={item.id}
              className="border-line px-5 last:border-b-0"
            >
              <AccordionTrigger className="text-[15px] font-semibold text-brand-plum">
                {item.title}
              </AccordionTrigger>
              <AccordionContent className="text-[15px] leading-relaxed text-muted">
                {item.content}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default Faq;
